import React from "react";
import { Footer } from "../components/footer";
import Transition from "../utils/Transition";

const ConferenceProgram = () => {
  const programDocumentUrl =
    "https://docs.google.com/document/d/1AxrJU2w6tvelc_GVgK3qpUKh4oaHGsDY_zzY3d0Rqqw/edit?usp=sharing";
  const embeddedProgramDocumentUrl =
    "https://docs.google.com/document/d/1AxrJU2w6tvelc_GVgK3qpUKh4oaHGsDY_zzY3d0Rqqw/preview";

  return (
    <Transition>
      <div className="flex flex-col min-h-screen bg-gray-50">
        <div className="flex-grow my-20 px-4 lg:px-36">
          <div className="bg-white shadow-xl rounded-lg p-8">
            <div className="text-center">
              <h1 className="text-3xl font-bold mb-6 text-gray-800 leading-tight">
                The 2026 Conference on Applications of Technology, Automation,
                and Civil Engineering
              </h1>
              <h2 className="text-2xl text-indigo-600 mb-8 font-semibold">
                ATAC 2026 AGENDA
              </h2>
              <div className="text-xl text-gray-700 space-y-4 mb-8">
                <p>
                  <strong>Time:</strong> March 19-20, 2026
                </p>
                <p>
                  <strong>Venue:</strong> 81 Nam Ky Khoi Nghia, Binh Duong
                  Ward, Ho Chi Minh City
                </p>
              </div>
              <div className="mx-auto mb-8 flex w-full max-w-5xl justify-center">
                <a
                  href={programDocumentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center rounded-full bg-indigo-600 px-6 py-3 text-sm font-semibold text-white transition hover:bg-indigo-700"
                >
                  Open Full Program Document
                </a>
              </div>
              <div className="mx-auto flex w-full max-w-5xl justify-center">
                <div className="w-full overflow-hidden rounded-2xl border border-gray-200 shadow-lg">
                  <iframe
                    src={embeddedProgramDocumentUrl}
                    title="ATAC 2026 Program Document"
                    className="mx-auto h-[900px] w-full"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </Transition>
  );
};

export default ConferenceProgram;
